import { render, staticRenderFns } from "./homeplace-section.vue?vue&type=template&id=40287c0c"
import script from "./homeplace-section.vue?vue&type=script&lang=js"
export * from "./homeplace-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports